
export const addItem = item => {
    return {
        type: 'ADD_ITEM',
        item
    };
};

export const setActiveMarker = activeMarker => {
    return {
        type: 'ACTIVE_MARKER',
        activeMarker
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js